import { AxiosStatic } from "axios";
import { InjectionKey } from "vue";
import { Router } from "vue-router";

export const axiosSymbol = Symbol() as InjectionKey<AxiosStatic>;
export const routerSymbol = Symbol() as InjectionKey<Router>;